import { useTranslation } from "react-multi-lang"
import MyDialog from "../../../components/Dialog/dialog"
import { useEffect, useState } from "react"
import TreeSelect from "../../../components/TreeCheckbox/TreeCheckbox"
import API from "../../../services/api/api"
import { useNotification } from "../../../services/usenotification"
import { Grid } from "@mui/material"
import { useCookies } from "react-cookie"
import { useAPI } from "../../../services/hoc/useAPI"
interface iProps {
    setOpen:Function,
    open:boolean,
    id:number

}
export default function ShowRole ({setOpen,open,id}:iProps){
const t=useTranslation()
const {alertError500}=useNotification()
let [nodes,setNode]=useState<any[]>([])
const [checked, setChecked] = useState<string[]>([]);
const Endpoint = useAPI()
const showRole= (id:number)=>{
    Endpoint.roles().show({id}).
    then((res:any)=>{
        if (res.data.data && res.data.data.permissions){
            let checked_values:string[]=[]
            let thenodes:any={}
            res.data.data.permissions.map((ele:any)=>{
                if (thenodes[ele.Category]&& thenodes[ele.Category].length>0){
                    if (ele.id && ele.name)
                    thenodes[ele.Category].push({value:ele.id,label:ele.name})
                    checked_values.push(ele.id)

                }
                else {
                    thenodes[ele.Category]=[{value:ele.id,label:ele.name}]
                    checked_values.push(ele.id)
                }
                
            })
            setNode(Object.keys(thenodes).map((ele:string)=>({value:ele,label:ele
                ,children:thenodes[ele as any]}))
            )
            setChecked(checked_values)
        }
    })
    .catch((err:any)=>
        alertError500(err)
        )
}
useEffect(()=>{
    if (id)showRole(id)
},[id])

    return (
        <>
       { open &&
        (<MyDialog setOpen={setOpen} open={open} title={t("role_details")}>
            <Grid container paddingTop={2}>

                 <TreeSelect 
                 checked={checked}
                 setChecked={setChecked}
                nodes={nodes}
                disabled={true}
                
                />
            </Grid>
             
        </MyDialog>)
        
    }</>
    )
}